// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3voxL","left":"InfoRow_left__5Va-Z"};